











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CloseButton extends Vue {
    @Prop({ default: ''}) public classes: string;
    @Prop({ default: null}) public top: number;
    @Prop({ default: null}) public bottom: number;
    @Prop({ default: null}) public left: number;
    @Prop({ default: null}) public right: number;

    @Prop({ default: false }) public useIcon: boolean;
    @Prop({ default: false }) public withBlur: boolean;

    constructor() {
        super();
    }

    get positionStyles() {
        let position = '';

        if (this.top !== null) {
            position += position + `top: ${this.top}px;`;
        }

        if (this.bottom !== null) {
            position += position + `bottom: ${this.bottom}px;`;
        }

        if (this.left !== null) {
            position += position + `left: ${this.left}px;`;
        }

        if (this.right !== null) {
            position += position + `right: ${this.right}px;`;
        }

        return position;
    }
}
